import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this._update();
    this._onResize = this._update.bind(this);
    window.addEventListener("resize", this._onResize);

    // Watch the toolbar above the canvas — it can wrap to a second line on
    // narrow viewports, which changes `top` without triggering window resize.
    this._roAbove = new ResizeObserver(this._update.bind(this));
    let el = this.element.previousElementSibling;
    while (el) {
      this._roAbove.observe(el);
      el = el.previousElementSibling;
    }
  }

  disconnect() {
    window.removeEventListener("resize", this._onResize);
    this._roAbove?.disconnect();
    this.element.style.height = "";
  }

  _update() {
    const top = this.element.getBoundingClientRect().top;
    let bottomPad = 0;
    let el = this.element.parentElement;
    while (el && el !== document.documentElement) {
      bottomPad += parseInt(getComputedStyle(el).paddingBottom, 10) || 0;
      el = el.parentElement;
    }
    this.element.style.height = `${window.innerHeight - top - bottomPad}px`;
  }
}
